'use es6';

import { createSelector } from 'reselect';
import { selectHasBusinessUnitsAccess } from 'dashboard-lib/public/userInfo/scopes';
export const CHECKBOX = 'CHECKBOX';
const NAME = 'NAME';
const REPORT_OWNER_NAME = 'REPORT_OWNER_NAME';
export const BUSINESS_UNIT = 'BUSINESS_UNIT';
const DELETED_BY = 'DELETED_BY';
export const DELETED_AT = 'DELETED_AT';
const ALL_COLUMNS = [{
  key: CHECKBOX,
  width: '70px'
}, {
  key: NAME,
  labelKey: 'reports.restore.table.header.NAME',
  width: '350px'
}, {
  key: REPORT_OWNER_NAME,
  labelKey: 'reports.restore.table.header.REPORT_OWNER_NAME',
  width: '200px'
}, {
  key: BUSINESS_UNIT,
  labelKey: 'reports.restore.table.header.BUSINESS_UNIT',
  getVisibility: ({
    hasBusinessUnitsAccess
  }) => hasBusinessUnitsAccess,
  width: '200px'
}, {
  key: DELETED_BY,
  labelKey: 'reports.restore.table.header.DELETED_BY',
  width: '200px'
}, {
  key: DELETED_AT,
  labelKey: 'reports.restore.table.header.DELETED_DATE',
  width: '200px'
}];
export const selectRestoreReportsVisibleColumns = createSelector(selectHasBusinessUnitsAccess, hasBusinessUnitsAccess => ALL_COLUMNS.filter(columnData => !columnData.getVisibility || columnData.getVisibility({
  hasBusinessUnitsAccess
})));